import veterinarians from './veterinarians';

export const locations = () => {
    const locs = [];
    Object.keys(veterinarians).map(province => province && veterinarians[province].map(location => locs.push(location)));
    return locs;
};

export default locations;
